import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@apollo/client';
import {
  GET_HUB_LIST,
  GetHubListResponse
} from '../graphql/queries/getHubList';

interface HubSelectWrapperProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
}

export const HubSelectWrapper: React.FC<HubSelectWrapperProps> = ({
  value,
  onChange,
  placeholder = '选择Hub'
}) => {
  const { data: allData, loading: allLoading } = useQuery<GetHubListResponse>(GET_HUB_LIST);

  const options = React.useMemo(() => {
    const list = allData?.hubList || [];

    return list
      .filter(hub => hub.siteType === 1) // 仅HUB类型
      .map(hub => {
        const firstSegment = hub.sortingCode?.split('-')[0] || '';
        const hubId = hub.id || 0;
        return {
          label: `${hub.name || ''}${firstSegment ? ` (${firstSegment})` : ''} (ID: ${hubId})`,
          value: hubId,
          searchText: `${hub.name || ''} ${firstSegment} ${hub.sortingCode || ''} ${hubId}`
        };
      });
  }, [allData]);

  const handleChange = (val: number | null) => {
    if (onChange) {
      onChange(val !== null ? val : undefined);
    }
  };

  return (
    <Select
      showSearch
      allowClear
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      loading={allLoading}
      options={options}
      filterOption={(input, option) => {
        const searchText = (option as any)?.searchText || '';
        return searchText.toLowerCase().includes(input.toLowerCase());
      }}
      className="w-full"
    />
  );
};

export default HubSelectWrapper;

